import mainLocationsStore from "@mobx/store/locations";
import { useMemo } from "react";

const usePlaceID3 = (isLocation: boolean) => {
  const placeIDString = useMemo(
    () => isLocation
      ? mainLocationsStore.activeLocation?.location.Id
      : mainLocationsStore.activeLocation?.activeBuilding?.building.id,
    [mainLocationsStore.activeLocation?.activeBuilding]
  );

  const placeID = useMemo(() => {
    let result: number | undefined;
    if (typeof placeIDString !== "undefined") {
      result = +placeIDString;
    }
    return result;
  }, [placeIDString, isLocation]);

  return { placeID };
};

export default usePlaceID3;